import styled from 'styled-components'

export const Container = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  align-items: stretch;
  gap: 16px;
  flex: ${({ $fullWidth }) => ($fullWidth ? '1' : 'initial')};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    gap: 12px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }

  @media print {
    display: flex !important;
    width: 100%;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: nowrap;
  }
`
